import Constant from '../Utils/Constant';

// Affichée à la place de tout le site quand la config MAINTENANCE_MODE vaut 1.
// Même visuel que maintenance/index.html, servie pendant les déploiements.
const MaintenancePage = () => {
    const handleRetryClick = () => {
        window.location.reload();
    };

    return (
        <div className="maintenance-page">
            <div className="maintenance-content">
                {/* Titre principal */}
                <h1 className="maintenance-title">503</h1>

                {/* Message de maintenance */}
                <p className="maintenance-message">
                    {Constant.MAINTENANCE_TITLE}
                </p>

                <p className="maintenance-description">
                    {Constant.MAINTENANCE_MESSAGE}
                </p>

                <p className="maintenance-subtitle">
                    {Constant.MAINTENANCE_DESCRIPTION}
                </p>

                {/* Bouton d'action */}
                <button
                    className="btn btn-primary btn-lg"
                    onClick={handleRetryClick}
                >
                    <i className="fas fa-redo me-2"></i>
                    {Constant.TRY_AGAIN}
                </button>
            </div>
        </div>
    );
};

export default MaintenancePage;
